import { Navbar } from "./Component/Navbar/Navbar";
import { Sidebar } from "./Component/Sidebar/Sidebar";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import PropTypes from "prop-types";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import SidebarRight from "./Component/SidebarRight/SidebarRight";
import Video from "./Component/Video/Video";
import Marketplace from "./Component/Marketplace/Marketplace";
import Groupe from "./Component/Groupes/Groupe";
import Games from "./Component/Games/Games";
import HomeScreen from "./Component/HomeScreen/HomeScreen";
import Bookmarks from "./Pages/Bookmarks/Bookmarks";
import ProfilePage from "./Pages/ProfilePage/ProfilePage";

/**
 * Layout Component - Provides consistent layout across pages
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Page content
 * @returns {React.ReactElement} Layout wrapper
 */
const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className="homecontainer d-flex justify-content-between w-full">
        <Sidebar />
        {children}
        <SidebarRight />
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

/**
 * App Component - Main application component
 * Handles routing and page structure
 * @returns {React.ReactElement} Application root
 */
const App = () => {
  // Create a basic MUI theme
  const theme = createTheme({
    palette: {
      primary: {
        main: "#1877f2",
      },
      secondary: {
        main: "#f02849",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div className="app">
        <BrowserRouter>
        <Routes>
          {/* Home Routes */}
          <Route
            path="/FacebookClone"
            exact
            element={
              <Layout>
                <HomeScreen />
              </Layout>
            }
          />
          <Route
            path="/"
            exact
            element={
              <Layout>
                <HomeScreen />
              </Layout>
            }
          />

          {/* Video Route */}
          <Route
            path="/video"
            exact
            element={
              <Layout>
                <Video />
              </Layout>
            }
          />

          {/* Marketplace Route */}
          <Route
            path="/marketplace"
            exact
            element={
              <>
                <Navbar />
                <div className="marketplace-Container d-flex">
                  <Sidebar />
                  <Marketplace />
                </div>
              </>
            }
          />

          {/* Groups Route */}
          <Route
            path="/groups"
            exact
            element={
              <Layout>
                <Groupe />
              </Layout>
            }
          />

          {/* Games Route */}
          <Route
            path="/games"
            exact
            element={
              <Layout>
                <Games />
              </Layout>
            }
          />

          {/* Bookmarks Route */}
          <Route
            path="/bookmarks"
            element={
              <>
                <Navbar />
                <Bookmarks />
              </>
            }
          />

          {/* Profile Route */}
          <Route
            path="/profile"
            element={
              <>
                <Navbar />
                <ProfilePage />
              </>
            }
          />

          {/* 404 Fallback */}
          <Route
            path="*"
            element={
              <Layout>
                <div className="error-page text-center p-5">
                  <h1>404</h1>
                  <p>Page not found</p>
                </div>
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
    </ThemeProvider>
  );
};

export default App;
